module.exports = __webpack_public_path__ + "img/IMG-Vendor-bg2.d060ecc9.png";